import React, { useState } from "react";
import video from "../assets/video.mp4";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CryoTheropy from "../assets/cryotherapy.jpg";

const Banner = ({ videoSrc, title, bannerInfo, buttonText }) => {
  const { i18n, t } = useTranslation();
  const [isVideoReady, setIsVideoReady] = useState(false);
  return (
    <div className="relative h-[90vh] ">
      <div className="w-full h-full relative">
        <img
          src={CryoTheropy}
          className={`w-full h-full object-cover ${
            isVideoReady ? "hidden" : "block"
          }`}
          alt="Cryo Theropy"
        />
        <video
          loop
          autoPlay
          muted
          playsInline
          preload="auto"
          className={`w-full h-full object-cover  ${
            isVideoReady ? "opacity-100" : "opacity-0"
          }`}
          onCanPlayThrough={() => {
            setIsVideoReady(true);
          }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="absolute inset-0 top-0 bg-black opacity-10" />

      <div className="absolute top-0 flex justify-center flex-col z-10 text-white h-full p-5 md:max-w-5xl left-0 font-Merriweather m-auto right-0 text-center">
        <h1
          className={`text-3xl !leading-tight md:text-6xl font-extrabold ${
            i18n.language === "cn" ? "font-poppins" : ""
          }`}
        >
          {title}
        </h1>
        {/* <p className={`mt-10 text-sm  ${i18n.language === 'cn' ? 'font-poppins' : ''}}`}>{bannerInfo}</p> */}
        <button className="w-64 mx-auto h-12 font-bold text-white mt-10 bg-[rgb(161,121,61)] transition-colors duration-300 rounded-md shadow-md hover:shadow-lg">
          <Link
            to="https://www.vagaro.com/artistryspanwellness"
            target="_blank"
          >
            {buttonText}
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Banner;
